export default __webpack_public_path__ + "static/28-7cd9e5c7c31c24edc6aee4f5d41aed81.png";